/*
 * "These scents match your selection" -- de tweede slider in het winkelmandje.
 *
 * Beveelt geuren aan op basis van drie signalen, in deze volgorde van gewicht:
 *
 *   1. de uitkomst van de quiz, als iemand die heeft gedaan
 *   2. gedeelde geurfamilies met wat er al in het mandje ligt
 *   3. gedeelde noten
 *
 * De kandidatenlijst komt een keer van de winkel en blijft daarna in het
 * geheugen van het tabblad. Het mandje rendert opnieuw bij elke wijziging; de
 * lijst opnieuw ophalen zou dat bij elke plus- en minknop doen.
 */
(function () {
  /* v2: met producttype (gender); een oude lijst zonder type wordt dan niet meer gebruikt. */
  var CACHE_KEY = 'sentir:match:products:v2';
  var QUIZ_KEY = 'sentir:quiz:result';
  /* De nieuwe geurquiz bewaart zijn antwoorden per tabblad (sessionStorage) onder deze sleutel. */
  var GEURQUIZ_KEY = 'sentir:geurquiz';

  /* Quizfamilie (sleutel uit quiz-config.json) naar de familietag op het product. */
  var QUIZ_FAMILIE_TAG = {
    bloemig: 'floral', houtachtig: 'woody', gourmand: 'gourmand', musky: 'musky', amber: 'amber',
    citrus: 'citrus', aquatisch: 'aquatic', fruitig: 'fruity', kruidig: 'spicy',
  };
  var DEADLINE_KEY = 'sentir:match:deadline';

  /*
   * De families, de noten en het afleiden van de labels staan in
   * sentir-scent-labels.js -- de quiz toont dezelfde pillen en moet dezelfde
   * lijst gebruiken. Het scripttag staat vóór dit bestand in de sectie.
   */
  var LABELS = window.SentirScentLabels || {};
  var FAMILIES = LABELS.FAMILIES || [];
  var NOTES = LABELS.NOTES || [];

  /*
   * Deze drie worden bij elke render opnieuw gezet. Het winkelmandje vervangt
   * zijn eigen inhoud via innerHTML, en dan is de oude root een losse node die
   * nergens meer in de pagina hangt.
   */
  var root = null;
  var data = null;
  var list = null;
  var incentive = null;

  /* De kandidatenlijst halen we een keer op en houden we vast over renders heen. */
  var productsPromise = null;

  /* --------------------------------------------------------------- signalen -- */

  function geurquiz() {
    try {
      var raw = window.sessionStorage.getItem(GEURQUIZ_KEY);
      return raw ? JSON.parse(raw) || null : null;
    } catch (error) {
      return null;
    }
  }

  /*
   * De families uit de quiz, als tags. Eerst de nieuwe geurquiz (2-3 families),
   * anders de oude quiz (één code, bijvoorbeeld "amber").
   */
  function quizFamilies() {
    var antwoorden = geurquiz();
    if (antwoorden && Array.isArray(antwoorden.v2) && antwoorden.v2.length) {
      return antwoorden.v2
        .map(function (sleutel) { return QUIZ_FAMILIE_TAG[String(sleutel).toLowerCase()]; })
        .filter(Boolean);
    }
    try {
      var raw = window.localStorage.getItem(QUIZ_KEY);
      if (!raw) return [];
      var oud = String(JSON.parse(raw).key || '').toLowerCase();
      return oud ? [oud] : [];
    } catch (error) {
      // Safari in privemodus, of iets ouds in de opslag. Dan zonder quizsignaal.
      return [];
    }
  }

  /* "Voor haar" of "voor hem" uit de geurquiz van deze sessie, anders null. */
  function quizGender() {
    var antwoorden = geurquiz();
    if (!antwoorden) return null;
    if (antwoorden.v1 === 'haar') return 'women';
    if (antwoorden.v1 === 'hem') return 'men';
    return null;
  }

  /*
   * Op nl.sentirparfum.com vertaalt Weglot het producttype in products.json:
   * "Women" komt binnen als "Dames", "Men" als "Heren". De tags blijven Engels.
   * Zonder deze vertaaltabel vielen op de NL-site alle dames- en herengeuren
   * weg en bleef alleen unisex over (live gezien, 24 okt 2026).
   */
  var GENDER_NAMEN = {
    women: 'women', dames: 'women', vrouwen: 'women', vrouw: 'women',
    men: 'men', heren: 'men', mannen: 'men', man: 'men',
    unisex: 'unisex',
  };

  function genderVan(type) {
    return GENDER_NAMEN[String(type || '').trim().toLowerCase()] || null;
  }

  /*
   * Welke genders passen bij dit mandje:
   *   alleen dames (evt. + unisex)  -> dames + unisex
   *   alleen heren (evt. + unisex)  -> heren + unisex
   *   dames en heren                -> alles (iemand koopt voor twee), met van elk minstens één
   *   alleen unisex of niets        -> unisex; weten we uit de quiz "voor haar/hem", dan dat + unisex
   * Een man die unisex koopt hoort geen damesgeur te zien, en andersom.
   */
  function genderPlan(cartTypes) {
    var telling = { women: 0, men: 0, unisex: 0 };
    (cartTypes || []).forEach(function (regel) {
      var g = genderVan(regel && regel.t);
      if (g) telling[g] += Number(regel.q) || 1;
    });
    if (telling.women && telling.men) return { toegestaan: ['women', 'men', 'unisex'], gemengd: true, voorkeur: null };
    /* aandeel: welk deel van de geuren in het mandje dat gender heeft; bepaalt hoeveel suggesties het krijgt. */
    var totaal = telling.women + telling.men + telling.unisex;
    if (telling.women) return { toegestaan: ['women', 'unisex'], gemengd: false, voorkeur: 'women', aandeel: telling.women / totaal };
    if (telling.men) return { toegestaan: ['men', 'unisex'], gemengd: false, voorkeur: 'men', aandeel: telling.men / totaal };
    var quiz = quizGender();
    if (quiz) return { toegestaan: [quiz, 'unisex'], gemengd: false, voorkeur: quiz, aandeel: 0 };
    return { toegestaan: ['unisex'], gemengd: false, voorkeur: null };
  }

  function labelsFor(tags) {
    return LABELS.labelsFor ? LABELS.labelsFor(tags) : [];
  }

  /* ----------------------------------------------------------------- scoren -- */

  function score(product, cartFamilies, cartNotes, wensFamilies) {
    var tags = (product.tags || []).map(function (t) { return String(t).toLowerCase(); });
    var punten = 0;

    cartFamilies.forEach(function (f) { if (tags.indexOf(f) > -1) punten += 3; });
    cartNotes.forEach(function (n) { if (tags.indexOf(n) > -1) punten += 1; });

    /*
     * De quiz weegt het zwaarst. Iemand die vijf vragen heeft beantwoord heeft
     * daarmee meer over zijn smaak gezegd dan met wat er toevallig in het
     * mandje ligt.
     */
    (wensFamilies || []).forEach(function (f) { if (tags.indexOf(f) > -1) punten += 6; });

    /* Bestsellers als tiebreak, zodat gelijke scores niet alfabetisch eindigen. */
    if (tags.indexOf('bestseller') > -1) punten += 0.5;

    return punten;
  }

  /* ------------------------------------------------------------- kandidaten -- */

  function loadProducts() {
    if (productsPromise) return productsPromise;

    productsPromise = fetchProducts();
    return productsPromise;
  }

  function fetchProducts() {
    try {
      var cached = window.sessionStorage.getItem(CACHE_KEY);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (error) {
      /* geen cache, gewoon ophalen */
    }

    return window
      .fetch('/collections/' + encodeURIComponent(data.collection) + '/products.json?limit=250')
      .then(function (response) {
        if (!response.ok) throw new Error('status ' + response.status);
        return response.json();
      })
      .then(function (payload) {
        /* Alleen wat we nodig hebben bewaren; de rest is ballast in de opslag. */
        var slank = (payload.products || []).map(function (p) {
          var variant = (p.variants || [])[0] || {};
          var image = (p.images || [])[0] || null;
          return {
            handle: p.handle,
            title: p.title,
            tags: p.tags || [],
            type: p.product_type || '',
            price: variant.price,
            variantId: variant.id,
            available: Boolean(variant.available),
            image: image ? image.src : null,
          };
        });
        try {
          window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(slank));
        } catch (error) {
          /* vol of geblokkeerd; niet erg */
        }
        return slank;
      });
  }

  /* ----------------------------------------------------------------- prijzen -- */

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /*
   * Eerst het kortingsbedrag en dat er dan aftrekken, niet meteen het restant
   * uitrekenen. Shopify kapt de korting af op hele centen: 50% van EUR 14,95 is
   * EUR 7,47 korting en je betaalt EUR 7,48. Andersom gerekend kwam er EUR 7,47
   * uit en stond de kaart een cent onder de kassa.
   */
  function metKorting(cents, procent) {
    var korting = Math.floor((cents * procent) / 100);
    return cents - korting;
  }

  /*
   * Het percentage dat geldt zodra de klant deze geur toevoegt -- niet wat hij
   * nu heeft. Bij een parfum in het mandje levert toevoegen 20% op, dus dat is
   * de prijs die op de kaart hoort. De volle prijs tonen terwijl toevoegen hem
   * meteen verlaagt, klopt niet met wat de kassa doet.
   *
   * Loopt de aanbieding, dan wint die: 50% op een stuk is meer dan de staffel.
   */
  function kortingBijToevoegen(qty, halve) {
    if (halve) return data.matchPercentage;
    return tierFor(qty + 1);
  }

  /* ------------------------------------------------------------- de aanhef -- */

  function tierFor(qty) {
    if (qty >= 4) return data.tiers['4'] || 0;
    if (qty === 3) return data.tiers['3'] || 0;
    if (qty === 2) return data.tiers['2'] || 0;
    return 0;
  }

  /*
   * De teksten krijgen de echte bedragen mee, niet alleen een percentage.
   * "De helft van de prijs" is een claim; "EUR 7,48 in plaats van EUR 14,95" is
   * een feit, en dat rekent een klant niet zelf uit.
   */
  /*
   * Zelfde als fill, maar zet sterretjes om de ingevulde waarden. Die worden
   * verderop vet gezet: het percentage en het bedrag zijn waar de klant naar
   * kijkt, en in een lopende zin verdwijnen ze anders tussen de woorden.
   *
   * In de teksten zelf kun je ook **iets** vet maken, voor woorden die geen
   * waarde zijn -- "half price" bijvoorbeeld.
   */
  function fillVet(tekst, extra) {
    var gemarkeerd = {};
    Object.keys(extra || {}).forEach(function (sleutel) {
      gemarkeerd[sleutel] = '**' + extra[sleutel] + '**';
    });

    var uit = String(tekst || '');
    Object.keys(gemarkeerd).forEach(function (sleutel) {
      uit = uit.split('[' + sleutel + ']').join(gemarkeerd[sleutel]);
    });

    return uit
      .replace(/\[korting\]/g, '**' + data.matchPercentage + '%**')
      .replace(/\[helft\]/g, '**' + data.matchPercentage + '%**');
  }

  /*
   * Schrijft de tekst als echte elementen in plaats van als HTML-string. Wat
   * tussen sterretjes staat wordt <strong>; de rest blijft platte tekst, dus
   * een aanhalingsteken of een & in de theme editor kan nooit iets breken.
   */
  function schrijfVet(doel, tekst) {
    doel.textContent = '';

    String(tekst).split('**').forEach(function (deel, i) {
      if (!deel) return;
      if (i % 2 === 1) {
        var sterk = document.createElement('strong');
        sterk.textContent = deel;
        doel.appendChild(sterk);
      } else {
        doel.appendChild(document.createTextNode(deel));
      }
    });
  }

  function fill(tekst, extra) {
    var uit = String(tekst || '');

    /*
     * Eerst de waarden die bij deze ene tekst horen, dan pas de algemene. Zou
     * je het omdraaien, dan wordt [korting] altijd de halveprijskorting -- ook
     * in de staffeltekst, waar het percentage van de volgende trede hoort.
     */
    Object.keys(extra || {}).forEach(function (sleutel) {
      uit = uit.split('[' + sleutel + ']').join(extra[sleutel]);
    });

    return uit
      .replace(/\[korting\]/g, data.matchPercentage + '%')
      .replace(/\[helft\]/g, data.matchPercentage + '%');
  }

  /*
   * Het goedkoopste kandidaat-parfum bepaalt het bedrag in de aanhef. Zou je
   * het duurste nemen, dan klopt de belofte niet voor de kaart eronder waar de
   * klant naar kijkt.
   */
  function laagstePrijs(kandidaten) {
    var laagst = null;
    kandidaten.forEach(function (k) {
      var cents = Math.round(parseFloat(k.product.price) * 100);
      if (laagst === null || cents < laagst) laagst = cents;
    });
    return laagst;
  }

  function incentiveText(qty, kandidaten, halve) {
    var l = data.labels || {};

    if (halve) {
      var cents = laagstePrijs(kandidaten || []);
      var nuPrijs = cents === null ? null : metKorting(cents, data.matchPercentage);
      return fillVet(l.halfPriceNote, {
        prijs: nuPrijs === null ? '' : money(nuPrijs),
        was: cents === null ? '' : money(cents),
        bespaart: nuPrijs === null ? '' : money(cents - nuPrijs),
      });
    }

    var nu = tierFor(qty);
    var straks = tierFor(qty + 1);

    /*
     * Zit de klant al op de hoogste trede, dan is "voeg er een toe voor 40%"
     * onzin -- die 40% heeft hij al. Dan wijzen we vooruit naar de halve prijs.
     */
    if (straks > nu) {
      return fillVet(l.nextTier, { korting: straks + '%', aantal: String(qty + 1) });
    }

    /*
     * Wel genoeg parfums, maar geen halve prijs: de klok is afgelopen. Dan mag
     * er niets meer beloofd worden. Eerder viel dit geval door naar de tekst
     * hieronder, die zei "voeg nog 0 geuren toe en ontgrendel er een op 50%
     * korting" -- een aanbieding die niet meer bestaat, en een aantal dat
     * nergens op sloeg.
     */
    if (qty >= data.minimum) {
      return fillVet(l.maxTier, { huidig: nu + '%' });
    }

    var teGaan = data.minimum - qty;
    return fillVet(l.bridge, { aantal: String(teGaan), huidig: nu + '%' });
  }

  /* ----------------------------------------------------------- aftelling --- */

  /*
   * De aftelling betekent echt iets. Loopt hij af, dan verdwijnt de aanbieding
   * uit de slider: de prijzen gaan terug naar normaal en het kenmerk waarmee de
   * kassa de halve prijs geeft wordt niet meer meegestuurd.
   *
   * Dat is een bewuste keuze. Een klok die aftelt zonder gevolg is een truc die
   * je bij de eerste keer verversen doorhebt, en dan vertrouwt niemand de rest
   * van de pagina ook nog.
   *
   * Daarna komt de aanbieding terug, maar pas na de ingestelde wachttijd. Dat
   * is het verschil tussen een aanbieding die af en toe langskomt en een die er
   * altijd is: verversen, een nieuw tabblad of morgen terugkomen zet hem niet
   * terug -- alleen de tijd doet dat. Vandaar localStorage en niet
   * sessionStorage; met dat laatste was een nieuw tabblad al genoeg.
   */
  function deadline() {
    var minuten = parseInt(data.countdownMinutes, 10);
    if (!minuten || minuten < 1) return null;

    var duur = minuten * 60 * 1000;
    var wachttijd = Math.max(parseFloat(data.resetHours) || 0, 0) * 60 * 60 * 1000;
    var nu = Date.now();

    try {
      var opgeslagen = parseInt(window.localStorage.getItem(DEADLINE_KEY), 10);

      if (opgeslagen && !isNaN(opgeslagen)) {
        /* Loopt nog. */
        if (nu < opgeslagen) return opgeslagen;
        /* Geen wachttijd ingesteld: dan blijft hij afgelopen. */
        if (!wachttijd) return opgeslagen;
        /* Afgelopen, maar de wachttijd loopt nog. */
        if (nu < opgeslagen + wachttijd) return opgeslagen;
      }

      var nieuw = nu + duur;
      window.localStorage.setItem(DEADLINE_KEY, String(nieuw));
      return nieuw;
    } catch (error) {
      /* Geen opslag: dan telt hij vanaf nu, en verversen begint opnieuw. */
      return nu + duur;
    }
  }

  function resterend() {
    var eind = deadline();
    if (eind === null) return null;
    return Math.max(0, eind - Date.now());
  }

  function klok(ms) {
    var totaal = Math.floor(ms / 1000);
    var m = Math.floor(totaal / 60);
    var s = totaal % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  var tikker = null;

  /*
   * De klok staat in een eigen <time> met translate="no", los van de tekst
   * eromheen. Dat moet: staat de hele zin in een element, dan ziet Weglot bij
   * elke tik nieuwe tekst en vertaalt hij "Limited offer - 14:52", daarna
   * "Limited offer - 14:51", en zo elke seconde opnieuw.
   *
   * Zo vertaalt Weglot het label een keer en laat hij het getal met rust.
   * Dezelfde opzet als de bezorgteller in cart-drawer-deadline.liquid.
   */
  function toonKlok(over) {
    var head = root.querySelector('.cd-match__head');
    if (!head) return;

    var pill = head.querySelector('[data-cd-match-clock]');

    if (!pill) {
      pill = document.createElement('span');
      pill.className = 'cd-match__clock';
      pill.setAttribute('data-cd-match-clock', '');

      var delen = String(data.labels.countdown || '[tijd]').split('[tijd]');

      if (delen[0]) pill.appendChild(document.createTextNode(delen[0]));

      var tijd = document.createElement('time');
      tijd.setAttribute('data-cd-match-time', '');
      tijd.setAttribute('translate', 'no');
      /* Weglot kijkt naar zijn eigen klasse; translate="no" dekt de rest. */
      tijd.className = 'wg-notranslate';
      pill.appendChild(tijd);

      if (delen[1]) pill.appendChild(document.createTextNode(delen[1]));

      var kop = head.querySelector('.cd-match__heading');
      if (kop) kop.appendChild(pill);
    }

    /*
     * Alleen het getal bijwerken, niet de hele pill opnieuw opbouwen. Zou je
     * dat doen, dan ziet Weglot alsnog elke seconde een nieuw label.
     */
    var node = pill.querySelector('[data-cd-match-time]');
    if (node) node.textContent = klok(over);
  }

  function startKlok() {
    if (tikker) window.clearInterval(tikker);

    var over = resterend();
    if (over === null) return;

    toonKlok(over);
    tikker = window.setInterval(function () {
      var nu = resterend();
      if (nu === null) return;

      if (nu <= 0) {
        window.clearInterval(tikker);
        tikker = null;
        /* Afgelopen: opnieuw tekenen, nu zonder aanbieding. */
        render(laatsteProducten || []);
        return;
      }
      toonKlok(nu);
    }, 1000);
  }

  /* -------------------------------------------------------------- tekenen --- */

  var laatsteProducten = null;

  function render(products) {
    laatsteProducten = products;

    var qty = data.tierQty;
    var over = resterend();
    var halve = qty >= data.minimum && (over === null || over > 0);

    var cartHandles = data.cartHandles || [];
    var alleTags = (data.cartTags || []).map(function (t) { return String(t).toLowerCase(); });

    var cartFamilies = FAMILIES
      .map(function (f) { return f.toLowerCase(); })
      .filter(function (f) { return alleTags.indexOf(f) > -1; });
    var cartNotes = NOTES
      .map(function (nt) { return nt.toLowerCase(); })
      .filter(function (nt) { return alleTags.indexOf(nt) > -1; });

    var wens = quizFamilies();
    var plan = genderPlan(data.cartTypes);
    var aantal = Math.max(data.count || 4, 3);

    var gesorteerd = products
      .filter(function (p) {
        return (
          p.available &&
          p.variantId &&
          cartHandles.indexOf(p.handle) === -1 &&
          plan.toegestaan.indexOf(genderVan(p.type)) > -1
        );
      })
      .map(function (p) {
        return { product: p, punten: score(p, cartFamilies, cartNotes, wens) };
      })
      .sort(function (a, b) { return b.punten - a.punten; });

    var kandidaten = gesorteerd.slice(0, aantal);

    /*
     * Het gender is niet alleen een grens maar ook een voorkeur. Met twee unisex
     * en twee dames in het mandje scoren de unisexgeuren qua familie vaak het
     * hoogst, en dan bleven de suggesties unisex terwijl de klant net dames
     * toevoegde. Daarom:
     *   - mandje met dames (of heren, of quiz "voor haar/hem"): minstens de helft
     *     van dat gender, en meer naarmate het mandje er meer van heeft (3 dames
     *     op 5 geuren = 3 van de 4 suggesties); die staan vooraan;
     *   - dames én heren: van beide minstens één.
     * Een vervanger neemt de plek van de laagste die niet van dat gender is en
     * niet de laatste van zijn eigen soort (unisex mag altijd wijken).
     */
    function verzeker(gender, minimum) {
      var aanwezig = kandidaten.filter(function (k) { return genderVan(k.product.type) === gender; }).length;
      var extra = gesorteerd.filter(function (k) {
        return genderVan(k.product.type) === gender && kandidaten.indexOf(k) === -1;
      });
      while (aanwezig < minimum && extra.length) {
        var plek = -1;
        for (var i = kandidaten.length - 1; i >= 0; i--) {
          var soort = genderVan(kandidaten[i].product.type);
          if (soort === gender) continue;
          var zelfde = kandidaten.filter(function (k) { return genderVan(k.product.type) === soort; }).length;
          if (soort === 'unisex' || zelfde > 1) { plek = i; break; }
        }
        if (plek < 0) break;
        kandidaten[plek] = extra.shift();
        aanwezig++;
      }
    }

    if (plan.gemengd) {
      verzeker('women', 1);
      verzeker('men', 1);
    } else if (plan.voorkeur) {
      verzeker(plan.voorkeur, Math.max(Math.ceil(kandidaten.length / 2), Math.ceil(kandidaten.length * (plan.aandeel || 0))));
      /* De geuren van het gender van het mandje vooraan, verder op score. */
      var opScore = function (a, b) { return b.punten - a.punten; };
      kandidaten = kandidaten
        .filter(function (k) { return genderVan(k.product.type) === plan.voorkeur; })
        .sort(opScore)
        .concat(kandidaten.filter(function (k) { return genderVan(k.product.type) !== plan.voorkeur; }).sort(opScore));
    }

    if (!kandidaten.length) {
      root.hidden = true;
      klaarmelden();
      return;
    }

    var procent = kortingBijToevoegen(qty, halve);

    list.innerHTML = '';
    kandidaten.forEach(function (entry) {
      list.appendChild(card(entry.product, halve, procent));
    });

    if (incentive) schrijfVet(incentive, incentiveText(qty, kandidaten, halve));

    var klokPill = root.querySelector('[data-cd-match-clock]');
    if (halve) {
      startKlok();
    } else {
      if (tikker) { window.clearInterval(tikker); tikker = null; }
      if (klokPill) klokPill.remove();
    }

    root.hidden = false;
    klaarmelden();
  }

  /*
   * Deze slider vult zich pas na de render van het mandje, dus tot dat moment
   * is hij leeg en nul hoog. Wie de scrollpositie vasthoudt heeft dat te weten:
   * zie het anker in cart-drawer.js.
   */
  function klaarmelden() {
    document.dispatchEvent(new CustomEvent('sentir:match:rendered'));
  }

  function card(product, halve, procent) {
    var l = data.labels || {};
    var cents = Math.round(parseFloat(product.price) * 100);

    var item = document.createElement('li');
    item.className = 'cd-capsule cd-match__card';

    var top = document.createElement('div');
    top.className = 'cd-capsule__top';

    var media = document.createElement('a');
    media.className = 'cd-capsule__media';
    media.href = '/products/' + product.handle;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    if (product.image) {
      var img = document.createElement('img');
      /* width in de CDN-url: anders halen we een foto van 2000px op. */
      img.src = product.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2');
      img.alt = '';
      img.loading = 'lazy';
      img.width = 80;
      img.height = 80;
      media.appendChild(img);
    }
    top.appendChild(media);

    var info = document.createElement('div');
    info.className = 'cd-capsule__info';

    var titel = document.createElement('a');
    titel.className = 'cd-capsule__title cd-capsule__title--link';
    titel.href = '/products/' + product.handle;
    titel.textContent = product.title;
    info.appendChild(titel);

    var labels = labelsFor(product.tags);
    if (labels.length) {
      var chips = document.createElement('p');
      chips.className = 'cd-match__labels';
      labels.forEach(function (naam) {
        var chip = document.createElement('span');
        chip.className = 'cd-match__label';
        chip.textContent = naam;
        chips.appendChild(chip);
      });
      info.appendChild(chips);
    }

    var prijs = document.createElement('p');
    prijs.className = 'cd-capsule__price';
    if (procent > 0) {
      var was = document.createElement('s');
      was.setAttribute('translate', 'no');
      was.textContent = money(cents);
      prijs.appendChild(was);

      var nu = document.createElement('span');
      nu.className = 'cd-capsule__now';
      nu.setAttribute('translate', 'no');
      nu.textContent = money(metKorting(cents, procent));
      prijs.appendChild(nu);

      /*
       * De kortingspill staat achter het bedrag en niet op een eigen rij boven
       * de naam. Daar hoort hij ook: het is een uitspraak over de prijs, en het
       * scheelt de kaart een hele regel hoogte.
       */
      if (l.urgencyPill) {
        /*
         * Dezelfde badge als de eerste slider gebruikt, met dezelfde klasse.
         * Twee sliders onder elkaar met elk een eigen vorm voor hetzelfde
         * gegeven leest als twee verschillende soorten aanbieding.
         */
        var deal = document.createElement('span');
        deal.className = 'cd-capsule__badge';
        /* Het werkelijke percentage, niet altijd dat van de aanbieding. */
        deal.textContent = fill(l.urgencyPill, { korting: procent + '%' });
        prijs.appendChild(deal);
      }
    } else {
      var normaal = document.createElement('span');
      normaal.className = 'cd-capsule__now';
      normaal.setAttribute('translate', 'no');
      normaal.textContent = money(cents);
      prijs.appendChild(normaal);
    }
    info.appendChild(prijs);

    top.appendChild(info);
    item.appendChild(top);

    var row = document.createElement('div');
    row.className = 'cd-capsule__choose';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cd-capsule__add';
    /*
     * Ook bij de aanbieding gewoon "Add". Het bedrag staat twee regels hoger in
     * het vet; het nog eens op de knop zetten maakt de kaart drukker zonder er
     * iets aan toe te voegen.
     */
    button.textContent = l.addLabel || 'Add';
    button.setAttribute('aria-label', (l.addLabel || 'Add') + ' ' + product.title);

    button.addEventListener('click', function () {
      button.disabled = true;
      if (window.SentirCart.houdPlaats) window.SentirCart.houdPlaats(button);

      var payload = { items: [{ id: Number(product.variantId), quantity: 1 }] };

      /*
       * Alleen bij de halve prijs krijgt de regel het kenmerk. Daaronder is een
       * gewone toevoeging beter: dan telt het parfum mee voor de staffel, en
       * die is op dat moment meer waard dan niets.
       */
      if (halve) payload.items[0].properties = { _style_match: '1' };

      window.SentirCart.add(payload, { openDrawer: false }).catch(function () {
        button.disabled = false;
      });
    });

    row.appendChild(button);
    item.appendChild(row);

    return item;
  }

  /* ------------------------------------------------------------------ start -- */

  /*
   * Opnieuw opbouwen bij elke wijziging van het mandje. Dat moet vanuit hier en
   * niet door het script opnieuw te laden: het winkelmandje vervangt zijn
   * inhoud met innerHTML, en een <script> dat zo terugkomt voert de browser
   * niet uit. Zonder deze luisteraar draait de slider een keer en blijft hij
   * daarna verborgen -- precies wat er gebeurt zodra je er iets uit toevoegt.
   */
  function init() {
    root = document.querySelector('[data-cd-match]');
    if (!root) return;

    var dataNode = root.querySelector('[data-cd-match-data]');
    if (!dataNode) return;

    try {
      data = JSON.parse(dataNode.textContent);
    } catch (error) {
      console.warn('Match-slider: de gegevens zijn niet te lezen.', error);
      return;
    }

    list = root.querySelector('[data-cd-match-list]');
    incentive = root.querySelector('[data-cd-match-incentive]');
    if (!list) return;

    loadProducts()
      .then(render)
      .catch(function (error) {
        /* Geen aanbevelingen is jammer, een kapot winkelmandje niet. */
        console.warn('Match-slider: kon de geuren niet ophalen.', error);
        if (root) root.hidden = true;
      });
  }

  init();
  document.addEventListener('sentir:cart:updated', init);
})();
